import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { requestInitData } from "./requestInitData";
import { requestApiTexts } from "./requestApiTexts";
export var initDataAndApiTexts = createAsyncThunk('initDataAndApiTexts', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connectionData, _ref) {
    var dispatch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch;
          _context.next = 3;
          return dispatch(requestApiTexts());
        case 3:
          _context.next = 5;
          return dispatch(requestInitData());
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());